import { ISODateString } from "@m7-health/shared-utils";

import { APIElementResponse, SDTO } from "../_shared/types";
import { IHealthSystem } from "../healthSystem/types";
import { IMarket } from "../market/types";

export type IRegion = Region.DTO;

export namespace Region {
  export interface DTO extends SDTO.base, SDTO.withTimestamps {
    markets: IMarket[];
    healthSystemId: string;
    healthSystem: IHealthSystem;
    name: string;
    archivedAt: ISODateString | null;
  }

  export namespace API {
    export const ROOT_PATH = "/region";

    export namespace Update {
      export const PATH = (params: QueryParams) => `${ROOT_PATH}/${params.id}`;

      export type QueryParams = {
        id: DTO["id"];
        name?: string;
        healthSystemId?: string;
      };

      export type Response = APIElementResponse<DTO>;
    }

    export namespace Create {
      export const PATH = ROOT_PATH;

      export type QueryParams = {
        name: string;
        healthSystemId: string;
      };

      export type Response = APIElementResponse<DTO>;
    }

    export namespace Archive {
      export const PATH = (params: QueryParams) => `${ROOT_PATH}/${params.id}/archive`;

      export type QueryParams = {
        id: DTO["id"];
      };

      export type Response = APIElementResponse<DTO>;
    }

    export namespace Restore {
      export const PATH = (params: QueryParams) => `${ROOT_PATH}/${params.id}/restore`;

      export type QueryParams = {
        id: DTO["id"];
      };

      export type Response = APIElementResponse<DTO>;
    }
  }
}
